module.exports = [
    { 
        OMSKIY: { min: 3174, max: 3174 },
    },
    { 
        AMUR: { min: 3329, max: 3329 },
    },
    { 
        SORMOVSKIY: { min: 3353, max: 3353 },
    },
    { 
        SIBIRSKIY: { min: 3427, max: 3427 },
    },
    { 
        VOLGO_BALT: { min: 3474, max: 3474 },
    },
    { 
        VOLGO_DON: { min: 5885, max: 5885 },
    },
    { 
        HANDYSIZE: { min: 24000, max: 34999 },
    },
    { 
        HANDYMAX: { min: 35000, max: 49999 },
    },
    { 
        SUPRAMAX: { min: 50000, max: 59999 },
    },
    { 
        ULTRAMAX: { min: 60000, max: 64999 },
    },
    { 
        PANAMAX: { min: 65000, max: 79999 },
    },
    { 
        KAMSARMAX: { min: 80000, max: 82999 },
    },
    { 
        L_MODERN_ECOTYPE: { min: 80000, max: 99999 },
    },
    { 
        POSTPANAMAX: { min: 83000, max: 99999 },
    },
    { 
        AFRAMAX: { min: 80000, max: 120000 },
    },
    { 
        BABYCAPE: { min: 100000, max: 119999 },
    },
    { 
        CAPESIZE: { min: 120000, max: 189999 },
    },
    { 
        SUEZMAX: { min: 120000, max: 200000 },
    },
    { 
        NEWCASTLEMAX: { min: 190000, max: 209999 },
    },
    { 
        VLOC: { min: 210000, max: 379999 },
    },
    { 
        VALEMAX: { min: 380000, max: 400000 },
    },
];



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/VesselTypeSizes.js